// 画像編集モーダル
const ModalImageEditor = {
  namespaced: true,

  state: {
    modal: false,
    path: '',
    type: '',
    number: null,
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getPath: state => {
      return state.path
    },
    getType: state => {
      return state.type
    },
    getNumber: state => {
      return state.number
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setPath(state, path) {
      state.path = path
    },
    setType(state, type) {
      state.type = type
    },
    setNumber(state, number) {
      state.number = number
    },
  },
  actions: {
    show({ commit }, payload) {
      commit('setPath', payload.path)
      commit('setType', payload.type)
      commit('setNumber', payload.number)
      commit('setModal', true)
    },
    hide({ commit }) {
      commit('setModal', false)
      commit('setNumber', null)
      commit('setType', '')
      commit('setPath', '')
    },
  },
}

export default ModalImageEditor
